import { render, staticRenderFns } from "./DesignComponentsReviewData.vue?vue&type=template&id=576e270c&scoped=true"
import script from "./DesignComponentsReviewData.vue?vue&type=script&lang=js"
export * from "./DesignComponentsReviewData.vue?vue&type=script&lang=js"
import style0 from "./DesignComponentsReviewData.vue?vue&type=style&index=0&id=576e270c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576e270c",
  null
  
)

/* custom blocks */
import block0 from "./DesignComponentsReviewData.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports